import axios from 'axios';

export default axios.create({
    baseURL:'https://smsaur.vercel.app'
})
